import { Task } from 'app/data/types/tasks'
import { useTaskDialogStore } from 'app/utils/global-store/taskDialogStore'
import { useEffect, useMemo } from 'react'
import { shallow } from 'zustand/shallow'

const logTaskDialog = (_message: string, _data?: any) => {
  //console.log(`[useTaskDialog] ${message}`, data || '')
}

/**
 * Hook for managing the task dialog state and operations.
 * Provides a clean interface for opening/closing the dialog and managing the editing state.
 * Uses Zustand store to prevent multiple dialog instances from opening simultaneously.
 */
export function useTaskDialog() {
  const { visible, editingTask, defaultFocusDate, show, hide } = useTaskDialogStore(
    (state) => ({
      visible: state.visible,
      editingTask: state.editingTask,
      defaultFocusDate: state.defaultFocusDate,
      show: state.show,
      hide: state.hide,
    }),
    shallow
  )

  // Ensure dialog is properly closed on first mount/app refresh
  useEffect(() => {
    // This guarantees that when the app refreshes, the dialog will be closed
    const timerId = setTimeout(() => {
      if (visible) {
        // Only hide if it was accidentally set to visible during refresh
        hide()
        logTaskDialog('Dialog auto-closed on app refresh')
      }
    }, 0)

    return () => clearTimeout(timerId)
  }, [])

  return useMemo(() => {
    logTaskDialog('store access', {
      visible,
      hasEditingTask: !!editingTask,
      defaultFocusDate,
    })

    return {
      visible,
      editingTask,
      defaultFocusDate,
      show,
      hide,
    }
  }, [visible, editingTask, defaultFocusDate, show, hide])
}
